export default __webpack_public_path__ + "static/media/README.ef57c503.md";